import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const updateQuestionOperation = async (
  pollId: number,
  questionId: number,
  questionText: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (questionText.length < 2) {
      toast.warn('על טקסט השאלה להכיל לפחות 2 תווים');
      return;
    }
    setLoading(true);
    await appApi.updatePollQuestionText(pollId, questionId, questionText);
    await globalSettingsStores.fetchSetting();
    toast.success('השאלה עודכנה בהצלחה');
    setLoading(false);
    closeDialog();
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
